import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Button, Col, Modal, Row} from "react-bootstrap";
import Input from "../../../common/Input";
import {getGreekCurrencyFormat, isEmpty} from "../../../../_helpers/commonFunctions";
import moment from "moment";
import axios from "axios";
import {toast} from "react-toastify";
import {openSaleLocal} from "../../../../_helpers/tabOpeners";

const PrimerMonthlyPaymentDetails = (props) => {
    const dispatch = useDispatch();
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const [data, setData] = useState({
        startDate: "",
        endDate: "",
        tableData: [],
    });

    const isExpired = (sub) => {
        return moment(sub.endDate) < moment();
    }
    const isCancelled = (sub) => {
        if (sub?.cancelled_date) {
            if (moment(sub.cancelled_date, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
                return moment(sub.cancelled_date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm");
            }
        }
        return null;
    }

    const handleShowExistingSale = (payment) => {
        if (payment?.invoice_mark) {
            axios.get(process.env.REACT_APP_API_URL2 + "/sale/get-sale-by-mark", {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    company: props.company.id,
                    mark: payment.invoice_mark,
                }
            }).then((res) => {
                if (res.data.status === "200") {
                    dispatch(openSaleLocal(res.data.data, TABS_DATA));
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        }
    }

    useEffect(() => {
        if (props.show) {
            try {
                const dat = props.data;
                setData({
                    status: dat.status,
                    startDate: moment(dat.startDate).format("DD/MM/YYYY HH:mm:ss"),
                    endDate: !isEmpty(dat.endDate) ? moment(dat.endDate).format("DD/MM/YYYY HH:mm:ss") : "",
                })
            } catch (error) {
                console.log(error);
            }
        }
    }, [props.show, props.data])

    const getStatusText = (status) => {
        let mapTrans = {
            "active": "Ενεργή",
            "cancelled": "Ακυρωμένη",
            "on-hold": "Εκκρεμεί",
            "pending-cancel": "Εκκρεμεί ακύρωση",
            "expired": "Έχει λήξει",
        }
        return mapTrans[status] ? mapTrans[status] : status;
    }

    return (
        <React.Fragment>
            <Modal show={props.show} onHide={props.onHide} dialogClassName={"modal40PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Λεπτομέρειες Συνδρομής WooCommerce</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className={"mb-2"}>
                        <Col md={6}>
                            <Input label={"Αρ. Συνδρομής"} disabled={true} value={props.data.link_subscription_id} />
                        </Col>
                        <Col md={6}>
                            <Input label={"Κατάσταση"} disabled={true} value={
                                isExpired(props.data) ? isCancelled(props.data) ? getStatusText("cancelled")
                                    : getStatusText("expired") : getStatusText("active")
                            } />
                        </Col>
                    </Row>
                    <Row className={"mb-4"}>
                        <Col md={6}>
                            <Input label={"Ημερομηνία Έναρξης"} disabled={true} value={data.startDate} />
                        </Col>
                        <Col md={6}>
                            <Input label={"Ημερομηνία Λήξης"} disabled={true} value={isEmpty(data.endDate) ? "Χωρίς ημ/νια λήξης" : data.endDate} />
                        </Col>
                    </Row>
                    {props.data?.payments?.length > 0 && (
                        <Row>
                            <Col md={12}>
                                <div style={{textAlign: "center"}}><h6>Ιστορικό πληρωμών</h6></div>
                                <table style={{tableLayout: "fixed", width: "100%", textAlign: "center"}}>
                                    <thead>
                                    <tr>
                                        <th style={{border: "1px solid gray"}}>Ημ/νια πληρωμής</th>
                                        <th style={{border: "1px solid gray"}}>Αρ. Παραγγελίας</th>
                                        <th style={{border: "1px solid gray"}}>Ποσό πληρωμής</th>
                                        {!props.isPrimerConstructor && <th style={{border: "1px solid gray", width: "50px"}}>&nbsp;</th>}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {props.data?.payments?.map((payment, idx) => (
                                        <tr key={`orderRowEP${idx}`}>
                                            <td style={{border: "1px solid gray"}}>{isEmpty(payment.date) ? "-" : moment(payment.date).format("DD/MM/YYYY HH:mm:ss")}</td>
                                            <td style={{border: "1px solid gray"}}>{payment.order_id}</td>
                                            <td style={{border: "1px solid gray"}}>{getGreekCurrencyFormat(Number(payment.total_value))}</td>
                                            {!props.isPrimerConstructor &&
                                                (<td style={{
                                                    border: "1px solid gray",
                                                    width: "25px"
                                                }}>
                                                    <i className="fa-regular fa-file-lines"
                                                       style={{padding: 0, cursor: "pointer"}}
                                                       title={"Προβολή Πώλησης"}
                                                       onClick={() => handleShowExistingSale(payment)}>
                                                    </i>
                                                </td>)
                                            }
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={props.onHide}>
                        Κλείσιμο
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default PrimerMonthlyPaymentDetails;